module.exports = __webpack_public_path__ + "img/29.f2f759d6.jpg";